import {createAction, props} from '@ngrx/store';


export const loadNotificationSettings = createAction('[Customer] load notification Settings');
export const changeNotificationSetting = createAction('[notification item] change notification setting', props<{key: string, mail: boolean, telegram: boolean}>());
export const changeName = createAction('[Change Name] change name', props<{personaId: string, firstname: string, lastname: string}>());
export const loadName = createAction('[Change Name] load name', props<{personaId: string}>());
export const loadFeeds = createAction('[Ical-Feed] load feeds');
export const resetIcalFeed = createAction('[Ical-Feed] reset ical feed link');
